import * as React from "react";
import { ActivityStatus } from "../../../../../server/models/status";
import { reducer, initState } from "../../../reducers/activity/status";
import { Loading } from "../../../../../react-components/lu-component/src/index";
import { ActivityStatusPage } from "../../../components/pages/activity/status";
import { put, get, makeError } from "../../../lib/request";
import { GetActivityStatusResponse } from "../../../../../server/types/request/activity";
import { endpoint } from "../../../../../server/router/endpoint";
import { useParams } from "react-router-dom";
import { ConfirmBox } from "../../../components/parts/confirm-box";

export const ActivityStatusContainer = () => {
	const [state, dispatch] = React.useReducer(reducer, initState);
	const { loading, info, status } = state;
	const onChange = React.useCallback(
		(value: keyof typeof ActivityStatus) => dispatch({ type: "changeStatus", payload: value }),
		[],
	);
	const { activityId } = useParams<{ activityId: string }>();
	React.useEffect(() => {
		get<GetActivityStatusResponse>(`${endpoint.activityStatus}/${activityId}`)
			.then((response) => {
				dispatch({ type: "loadStatus", payload: response.data.status });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			});
	}, [activityId]);
	const onSubmit = React.useCallback(() => {
		put<GetActivityStatusResponse>(`${endpoint.activityStatus}/${activityId}`, { status })
			.then(() => {
				dispatch({ type: "changeMessageInfo", payload: { isSuccess: true, message: "更新が完了しました。" } });
			})
			.catch((error) => {
				dispatch({ type: "changeMessageInfo", payload: makeError(error) });
			});
	}, [activityId, status]);
	return (
		<>
			<ConfirmBox info={info} titleLabel={"更新処理"} />
			<Loading loading={loading} />
			<ActivityStatusPage status={status} onChnage={onChange} onSubmit={onSubmit} errors={info.errors} />
		</>
	);
};
